import $ from 'jquery';
import service from "../ajax/service";
const GAME_ID = '275';
export const initGameInfo = async () => {
    let gameRes = await service.getGameInfo(GAME_ID);
    if (+gameRes.result === 1) {
        const data = gameRes.data;
        data.apkDownLoadURL.length && $('.j-apk-link').attr('href', data.apkDownLoadURL);
        data.googlePlayDownLoadURL.length && $('.j-google-link').attr('href', data.googlePlayDownLoadURL);
        data.appStoreDownLoadURL.length && $('.j-apple-link').attr('href', data.appStoreDownLoadURL);
        data.qrCode.length && $('.j-qrcode').css('background-image', `url(${data.qrCode})`);
    }
}